/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2018 ICEMEDX, Inc.
***********************************************/
import { Component, OnInit, Input, Injectable, EventEmitter, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { IcecontrolSettings, IcecontrolPermission, iceColumnDefinition } from '../../components/models/icesettings';
import { userTypes } from '../../login/login.config';
import { Iceutility } from '../../services/iceutility';
import { IcematgridComponent } from '../icepanel/icematgrid.component';

export interface TabData {
  page: number;
  value: Object;
}

@Component({
  selector: 'icetab',
  templateUrl: './icetab.component.html',
  styleUrls: ['./icetab.component.scss'],
  providers: [IcematgridComponent]
})
@Injectable()

export class IcetabComponent implements OnInit {
  // Input Members
  @Input() id: string = "";
  @Input() properties: any = {};
  @Input() ctrl: IcecontrolSettings = null;
  @Input() tableColumn: iceColumnDefinition = null;
  @Input() tableRowData: any = null;
  @Input() matTableObject: IcematgridComponent = null;
  @Input() selectedIndex: number = 0;

  // Output Members
  @Output() InputChanged: EventEmitter<any> = new EventEmitter<any>();
  @Output() selectedIndexChange: EventEmitter<any> = new EventEmitter<any>();

  // Data Members
  iceFormControl: FormControl = null;
  permission: IcecontrolPermission = null;
  tabs: any[] = [];
  tabData: TabData[] = [];

  constructor() {
  }

  ngOnInit() {
    try {
      this.permission = this.ctrl.permissions ? this.ctrl.permissions : new IcecontrolPermission(userTypes.USER_FEATURES.ufNone, userTypes.USER_FEATURE_ACCESS.ufaNone);
      if (this.matTableObject && this.tableRowData != null && this.tableColumn != null) {
        // tables should not use the standard formcontrol
        let formRowGroup: FormGroup = this.matTableObject.getFormGroup(this.tableRowData);
        this.iceFormControl = new FormControl(this.tableRowData[this.tableColumn.columnName]);
        formRowGroup.addControl(this.tableColumn.columnName, this.iceFormControl);
      }
      else if (this.ctrl == null) {
        this.iceFormControl = new FormControl(''); // No control so we create a placeholder control to prevent an errors
      }
      else {
        this.iceFormControl = this.ctrl.getFormControl();
        if (this.iceFormControl == null)
          this.iceFormControl = new FormControl(''); // No control so we create a placeholder control to prevent an errors
      }

      if (this.permission.default_access === userTypes.USER_FEATURE_ACCESS.ufaReadOnly) {
        this.iceFormControl.disable();
      }
    }
    catch (e) {
      console.log(e);
    }
  }

  ngOnDestroy() {
  }

  public getStyle(): any {
    let style = {
      width: "100px",
      height: "100px"
    };

    if (this.ctrl == null || this.ctrl.properties == null) return style;

    if (Iceutility.isdefined(this.ctrl.properties.width)) {
      let width = this.ctrl.properties.width;
      style.width = Iceutility.contains(width, "%") ? width : Iceutility.contains(width, "px") ? width : width + "px";
    }
    if (Iceutility.isdefined(this.ctrl.properties.height)) {
      let height = this.ctrl.properties.height;
      style.height = Iceutility.contains(height, "%") ? height :Iceutility.contains(height, "px") ? height : height + "px";
    }
    return style;
  }

  onTabSelectionChange(index) {
    this.selectedIndex = index;
    this.selectedIndexChange.emit(this.selectedIndex);
  }

  renderAsControl(content): boolean {
    return content instanceof IcecontrolSettings;
  }

  onPageAdd(data) {
    let tabs = this.ctrl.properties.tabs;
    tabs.push({ label: data.label ? data.label : "Page " + (tabs.length + 1).toString() , content: data.tab });
    this.selectedIndex = tabs.length - 1;
  }

  onPageRemove() {
    if (this.ctrl.properties.tabs.length > 1) {
      this.ctrl.properties.tabs.splice(this.selectedIndex, 1);
      if (Iceutility.isdefined(this.tabData[this.selectedIndex])) {
        this.tabData.splice(this.selectedIndex, 1);
      }
      this.selectedIndex--;
    }
  }

  onPageDraw(data) {
    let pIndex = this.selectedIndex + 1;
    let tab = this.tabData.filter(x => x.page == pIndex);
    if (tab.length > 0) {
      tab[0].value = data;
    } else {
      this.tabData.push(<TabData>{ page: pIndex, value: data });
    }
    
    this.iceFormControl.setValue(this.tabData);
  }
}
